<app-academies-header></app-academies-header>

<!-- <app-coming-soon></app-coming-soon> -->

<section class="body-section academies-profile-inner ">
  <div class="container">
    <main>
      <div class=" col-md-12 bottom-container tablesections">
        <div class="header-container box w-100">
          <div class="col-md-12 d-flex justify-content-between mb-3 headers-headings">
            <h3 class="section-header">OUR TOURNAMENTS
            </h3>

            <div class="add-edit-btn">
              <ul>
                <li>
                  <a routerLink="/createtournament"><button class="add-btn-main">
                      <i class='bx bx-plus'></i> Create New <span style="font-weight: normal;" class="mobile-hide">
                        Tournament</span>
                    </button></a>
                </li>
                <!-- <li class="edit-save">
                                  <button class="edit-btn-main">
                                      <i class='bx bx-pencil'></i> Edit
                                  </button>
                                  <button class="save-btn-main">
                                      <i class='bx bxs-file'></i> Save
                                  </button>
                              </li> -->
              </ul>
            </div>

          </div>

          <div class="col-md-12 find-partner-page p-0">

            <div class="right-side-section col-md-12 p-0">


              <div class=" wrapper max-w-3xl mx-auto ">
                <div class=" item my-3 p-4 border" *ngFor="let tournaments of tournamentList">
                  <div class="row">

                    <div class="col-lg-12 ournament-main-div" (click)="onclickdetails(tournaments.id)"
                      style="cursor:pointer;">
                      <div class="media">
                        <div class="player-image mr-3">
                          <img [src]="(tournaments.academyPic) ? tournaments.academyPic : '../../../../assets/images/academy_dummy.jpg'" alt="" (click)="onclickdetails(tournaments.id)">
                        </div>
                        <div class="txt-l media-body">
                          <h3 class="tx-1" pTooltip="{{tournaments.name}}" tooltipPosition="bottom"
                            style="cursor: pointer;">{{tournaments.name}}
                          </h3>
                          <div class="list">
                            <div class="location">
                              <span style="font-weight: 600; font-size: 14px;">Location :</span>
                              {{tournaments.cityname}}

                            </div>

                            <ul class="Tournament__TournamentInfo--DNeNi">
                              <span style="margin-right: 0px; font-size: 14px; font-weight: 600;"
                                class="titles-cc">Categories :</span>
                              <!-- <li *ngFor="let tournamentCategories of tournaments?.tournamentCategories?.slice(0, 5)">
                                <div *ngIf="tournamentCategories?.length != 0" class="category-list-div">
                                  <span
                                    *ngFor="let matchtypeDatadd of tournamentCategories.matchtypeData; let i = index">
                                    {{ matchtypeDatadd.name }} <span class="comma">,</span>
                                  </span>
                                </div>
                              </li> -->
                              <li *ngFor="let tournamentCategories of tournaments?.matchDataArray?.slice(0, 3); let last = last">                                  
                                  {{tournamentCategories}} <ng-container *ngIf="!last">, </ng-container>
                                </li>
                                <span *ngIf="tournaments?.matchDataArray?.length > 3" class="view-more">
                                  ...</span>
                            </ul>


                            <!-- <ul class="Tournament__TournamentInfo--DNeNi">
                              <span style="margin-right: 0px; font-size: 14px;font-weight: 600;"
                                class="titles-cc">Categories :</span>
                              <li *ngFor="let tournamentCategories of tournaments.tournamentCategories">
                                <div *ngIf="tournamentCategories?.length != 0" class="category-list-div">
                                  <span *ngFor="let matchtypeDatadd of tournamentCategories.matchtypeData"
                                    class="category-list">
                                    {{ matchtypeDatadd.name }}<span class="comma">,</span>
                                    <span *ngIf="matchtypeDatadd?.length!=0">,</span>
                                  </span>
                                </div>
                              </li>

                            </ul> -->
                            <div class="location">
                              <span style="font-weight: 600; font-size: 14px">Surface :</span> {{tournaments.court}}

                            </div>

                          </div>

                        </div>


                      </div>
                      <div class="medai-right date-div">
                        <div class="date">{{ tournaments.startdate | date:'dd/MM/yyyy' }} - {{ tournaments.enddate |
                          date:'dd/MM/yyyy' }}</div>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <hr>
                      <div class="items-footers">

                        <ul>


                          <li>
                            <button (click)="onClickEditdraw(tournaments.id)">
                              <span><i class="bx bx-objects-vertical-bottom"></i>
                              </span>
                              Create / Update Draws</button>
                          </li>
                          <li><button (click)="onClicktournamentPlayerList(tournaments.id)">
                              <span><i class="bx bx-list-ul"></i></span>
                              Player Entries</button></li>
                          <!-- <li><button class="disabled-button ">
                              <span><i class="bx bx-list-ul"></i></span>
                              Player Entries</button></li> -->
                          <!-- <li> <button class="btn-red" (click)="onClickDelete()">
                              <span><i class=" bx bx-trash"></i></span>
                              Delete</button></li> -->
                          <li class="edit-tournament">

                            <button *ngIf="!tournaments.status" data-bs-toggle="modal"
                              (click)="onClickEditTournament(tournaments.id)">
                              <span><i class="bx bx-edit-alt"></i></span> Edit Tournament
                            </button>
                            <button *ngIf="tournaments.status" data-bs-toggle="modal"
                              (click)="onclickdetails(tournaments.id)">
                              <span><i class="bx bx-edit-alt"></i></span> View Tournament
                            </button>

                          </li>
                        </ul>

                      </div>
                    </div>

                  </div>
                </div>

                <!-- Modal -->

              </div>

            </div>


          </div>

          
          <div class="col-md-12 page-pagination-div">
            <p-paginator *ngIf="totalRecords > 0" [rows]="8" [paginator]="true" #paginator pageLinkSize="3" [totalRecords]="totalRecords"
                (onPageChange)="loadTournament($event)" [rowsPerPageOptions]=" pagination" [showPageLinks]="true"></p-paginator>
            <div *ngIf="totalRecords == 0">
                <span>
                    Tournament Data not available.
                </span>
            </div>
        </div>
        </div>

      </div>





    </main>
  </div>


</section>

<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>